export const initialValuesForgotPassword = {
  email: '',
};
